import { Col, DatePicker, Row, Select, Collapse, Card } from "antd";
import { CDBIcon, CDBTable, CDBTableBody, CDBTableHeader } from "cdbreact";
import { Container } from "react-bootstrap";
import NavBarPeiix from '../../NavBar';
import { useState } from "react";
const { Panel } = Collapse; // Desestructura Panel desde Collapse

const headerStyle = {
    borderTop: '1px solid #DCDCDC', // Borde superior
    borderBottom: '1px solid #DCDCDC', // Borde inferior
    backgroundColor: '#DCDCDC', // Fondo
    color: '#3E4144', // Color del texto
};

const Aclaraciones = () => {

    const [showGarantia, setShowGarantia] = useState(false);
    const [showSeguridad, setShowSeguridad] = useState(false);
    const [showContracargos, setShowContracargos] = useState(false);


    return (
        <>
            <div className="Aclaraciones">
                <NavBarPeiix />

                <div className='navbar-container' style={{ padding: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div className='navbar-imgl' style={{ flex: '0 0 auto' }}>
                        <h3 className=" fw-bold" style={{ color: '#3E3E3E', fontFamily: 'Montserrat, sans-serif', marginBottom: '0', display: 'flex', alignItems: 'center' }}>
                        <CDBIcon icon="tasks" /> Aclaraciones
                        </h3>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexGrow: 1 }}>

                    </div>
                </div>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        width: '100%',
                        gap: '50px',
                        padding: '50px',
                    }}
                >
                    <Card style={{ width: 400, background: showGarantia ? '#D9FFD5' : '#9A9A9A', color: showGarantia ? '#3E3E3E' : '#FFFFFF', border: showGarantia ? '1px solid #0E9600' : '1px solid #9A9A9A', position: 'relative', transition: 'background-color 0.3s, border-color 0.3s', fontFamily: 'Montserrat, sans-serif' }}>
                        <div
                            style={{ cursor: 'pointer', position: 'absolute', top: '10px', right: '10px' }}
                            onClick={() => setShowGarantia(!showGarantia)}
                        >
                            {showGarantia ? <CDBIcon icon="eye" /> : <CDBIcon icon="eye-slash" />}
                        </div>
                        <div style={{ marginTop: '10px' }}>
                            <p style={{ textAlign: 'left' }} className="fw-bold h4">
                                {showGarantia ? `$` : '******'}
                            </p>
                        </div>
                        <p style={{ textAlign: 'left' }} className="fw-bold h5">Garantía liquidada</p>
                    </Card>

                    <Card style={{ width: 400, background: showSeguridad ? '#D9FFD5' : '#9A9A9A', color: showSeguridad ? '#3E3E3E' : '#FFFFFF', border: showSeguridad ? '1px solid #0E9600' : '1px solid #9A9A9A', position: 'relative', transition: 'background-color 0.3s, border-color 0.3s', fontFamily: 'Montserrat, sans-serif' }}>
                        <div
                            style={{ cursor: 'pointer', position: 'absolute', top: '10px', right: '10px' }}
                            onClick={() => setShowSeguridad(!showSeguridad)}
                        >
                            {showSeguridad ? <CDBIcon icon="eye" /> : <CDBIcon icon="eye-slash" />}
                        </div>
                        <div style={{ marginTop: '10px' }}>
                            <p style={{ textAlign: 'left' }} className="fw-bold h4">
                                {showSeguridad ? `$` : '******'}
                            </p>
                        </div>
                        <p style={{ textAlign: 'left' }} className="fw-bold h5">Fondo de seguridad</p>
                    </Card>

                    <Card style={{ width: 400, background: showContracargos ? '#D9FFD5' : '#9A9A9A', color: showContracargos ? '#3E3E3E' : '#FFFFFF', border: showContracargos ? '1px solid #0E9600' : '1px solid #9A9A9A', position: 'relative', transition: 'background-color 0.3s, border-color 0.3s', fontFamily: 'Montserrat, sans-serif' }}>
                        <div
                            style={{ cursor: 'pointer', position: 'absolute', top: '10px', right: '10px' }}
                            onClick={() => setShowContracargos(!showContracargos)}
                        >
                            {showContracargos ? <CDBIcon icon="eye" /> : <CDBIcon icon="eye-slash" />}
                        </div>
                        <div style={{ marginTop: '10px' }}>
                            <p style={{ textAlign: 'left' }} className="fw-bold h4">
                                {showContracargos ? '' : '******'}
                            </p>
                        </div>
                        <p style={{ textAlign: 'left' }} className="fw-bold h5">Contracargos</p>
                    </Card>
                </div>

                <Container fluid>

                    <Container fluid>
                        <p className="fw-bold" style={{ color: "#3E4144", fontSize: '20px', fontFamily: 'Montserrat, sans-serif', textAlign: 'left', paddingLeft: '40px' }}>Opciones de Filtrado</p>
                        <div className="display-5 fw-bold h1" style={{ color: "black", padding: '10px' }}>
                            <Row className='m-3 d-flex justify-content-left' gutter={[8, 16, 24, 32]}>
                                <Col className="gutter-row" xs={24} sm={12} md={6} lg={4}>
                                    <DatePicker
                                        className="col-12"
                                        placeholder="Fecha Inicio"
                                        format="DD/MM/YYYY"
                                    />
                                </Col>

                                <Col className="gutter-row" xs={24} sm={12} md={6} lg={4}>
                                    <DatePicker
                                        className="col-12"
                                        placeholder="Fecha Fin"
                                        format="DD/MM/YYYY"

                                    />
                                </Col>

                                <Col className="gutter-row" xs={24} sm={12} md={6} lg={4}>
                                    <Select
                                        mode="multiple"
                                        className="col-12"
                                        showSearch
                                        placeholder="Urgencia"

                                        filterOption={(input, option) =>
                                            (option?.label ?? "")
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                        tagRender={() => null} // Oculta las etiquetas de las opciones seleccionadas
                                        options={[
                                            {
                                                value: "A Tiempo",
                                                label: "A Tiempo",
                                            },
                                            {
                                                value: "Por Vencer",
                                                label: "Por Vencer",
                                            },
                                            {
                                                value: "Fuera de Tiempo",
                                                label: "Fuera de Tiempo",
                                            },
                                        ]}
                                    />
                                </Col>
                                <Col className="gutter-row" xs={24} sm={12} md={6} lg={4}>
                                    <Select
                                        mode="multiple"
                                        className="col-12"
                                        showSearch
                                        placeholder="Estatus"

                                        filterOption={(input, option) =>
                                            (option?.label ?? "")
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                        tagRender={() => null} // Oculta las etiquetas de las opciones seleccionadas
                                        options={[
                                            {
                                                value: "Nueva",
                                                label: "Nueva",
                                            },
                                            {
                                                value: "Leida",
                                                label: "Leida",
                                            },
                                            {
                                                value: "Revision",
                                                label: "Revision",
                                            },
                                            {
                                                value: "Rechazada",
                                                label: "Rechazada",
                                            },
                                            {
                                                value: "Atendida",
                                                label: "Atendida (En proceso)",
                                            },
                                            {
                                                value: "Rechazada visto",
                                                label: "Rechazada Visto",
                                            },
                                            {
                                                value: "Rechazada por banco",
                                                label: "Rechazada por Banco",
                                            },
                                            {
                                                value: "Bloqueada",
                                                label: "Bloqueada",
                                            },
                                            {
                                                value: "Vencida",
                                                label: "Vencida",
                                            },
                                            {
                                                value: "Ganada",
                                                label: "Ganada",
                                            },
                                            {
                                                value: "Perdida",
                                                label: "Perdida",
                                            },
                                            {
                                                value: "Reabierta",
                                                label: "Reabierta",
                                            },
                                        ]}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </Container>
                <br />
                <CDBTable hover responsive maxHeight="70vh" scrollY style={{ fontSize: '16px', fontFamily: 'Montserrat, sans-serif' }}>
                    <CDBTableHeader>
                        <tr >
                            <th style={headerStyle}>Urgencia</th>
                            <th style={headerStyle}>Producto</th>
                            <th style={headerStyle}>Fecha de petición</th>
                            <th style={headerStyle}>Fecha límite de respuesta</th>
                            <th style={headerStyle}>Nombre de comercio</th>
                            <th style={headerStyle}>Sucursal</th>
                            <th style={headerStyle}>Monto disputado</th>
                            <th style={headerStyle}>Terminación de tarjeta</th>
                            <th style={headerStyle}>Estatus</th>
                        </tr>
                    </CDBTableHeader>
                    <br />
                    <CDBTableBody>
                        <tr>
                            <td>Por vencer</td>
                            <td>Ecommerce Loop</td>
                            <td>24/06/20024</td>
                            <td>28/06/20024</td>
                            <td>Demo Comercial Peiix</td>
                            <td>Suc 1</td>
                            <td>$ 1,000.00 MXN</td>
                            <td>0000</td>
                            <td>Revision</td>
                        </tr>
                        <tr>
                            <td>Por vencer</td>
                            <td>Ecommerce Loop</td>
                            <td>21/06/20024</td>
                            <td>27/06/20024</td>
                            <td>Demo Comercial Peiix</td>
                            <td>Suc 4</td>
                            <td>$ 1,000.00 MXN</td>
                            <td>1111</td>
                            <td>Revision</td>
                        </tr>
                        <tr>
                            <td>A tiempo</td>
                            <td>Ecommerce Loop</td>
                            <td>20/06/20024</td>
                            <td>26/06/20024</td>
                            <td>Demo Comercial Peiix</td>
                            <td>Suc 3</td>
                            <td>$2,000.00 MXN</td>
                            <td>1234</td>
                            <td>Revision</td>
                        </tr>
                    </CDBTableBody>
                </CDBTable>
            </div>
        </>
    );
}

export default Aclaraciones;